import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FULLSTORY_ELEMENTS } from "utils/fullstoryElements";
import { PRICING } from "../../landingContent";
import SectionHeading from "../SectionHeading";

const PricingSection = ({ pricingData, pricingRef, onOpenDemo }) => {
  const [billingPeriod, setBillingPeriod] = useState("monthly");

  if (!pricingData) {
    return null;
  }

  return (
    <section
      id="pricing"
      ref={pricingRef}
      className="landing-v2__section landing-v2__section--muted landing-v2-pricing"
      aria-labelledby="pricing-heading"
    >
      <div className="landing-v2__container">
        <SectionHeading
          headline={PRICING.headline}
          subheading={PRICING.copy}
          headingLevel={2}
        />

        <div className="landing-v2__card landing-v2-pricing__card">
          <div className="landing-v2-pricing__toggle" role="group" aria-label="Billing period">
            <button
              type="button"
              className={`landing-v2-pricing__toggle-btn ${billingPeriod === "monthly" ? "landing-v2-pricing__toggle-btn--active" : ""}`}
              onClick={() => setBillingPeriod("monthly")}
              aria-pressed={billingPeriod === "monthly"}
              data-fs-element={FULLSTORY_ELEMENTS.billing.selectMonthly}
            >
              Monthly
            </button>
            <button
              type="button"
              className={`landing-v2-pricing__toggle-btn ${billingPeriod === "annual" ? "landing-v2-pricing__toggle-btn--active" : ""}`}
              onClick={() => setBillingPeriod("annual")}
              aria-pressed={billingPeriod === "annual"}
              data-fs-element={FULLSTORY_ELEMENTS.billing.selectAnnual}
            >
              Yearly
              {billingPeriod !== "annual" ? (
                <span className="landing-v2-pricing__save-badge">
                  Save {pricingData.savings}
                </span>
              ) : null}
            </button>
          </div>

          <p className="landing-v2-pricing__price">
            {billingPeriod === "monthly" ? (
              <>
                ${pricingData.monthlyPrice}{" "}
                <span className="landing-v2-pricing__price-unit">/ month</span>
              </>
            ) : (
              <>
                ${pricingData.yearlyPrice}{" "}
                <span className="landing-v2-pricing__price-unit">/ year</span>
              </>
            )}
          </p>

          {billingPeriod === "annual" ? (
            <p className="landing-v2-pricing__savings-note">
              You save {pricingData.savings} compared to monthly!
            </p>
          ) : null}

          <div className="landing-v2__cta-row landing-v2__cta-row--center">
            <Link
              to="/auth/register"
              className="landing-v2__btn landing-v2__btn--primary landing-v2__btn--full-mobile"
              data-fs-element={FULLSTORY_ELEMENTS.landing.pricingTrial}
            >
              {PRICING.primaryCta}
            </Link>
            <button
              type="button"
              className="landing-v2__btn landing-v2__btn--secondary landing-v2__btn--full-mobile"
              onClick={onOpenDemo}
              data-fs-element={FULLSTORY_ELEMENTS.landing.pricingWatchDemo}
            >
              {PRICING.secondaryCta}
            </button>
          </div>

          <p className="landing-v2-pricing__trial-note">
            Free for 30 days. No credit card required.
          </p>

          <div className="landing-v2-pricing__district">
            <p className="landing-v2__subheading">{PRICING.districtLinkDescription}</p>
            <Link to="/for-administrators" className="landing-v2__link">
              {PRICING.districtLinkText} →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
